import React from 'react'
import logo from "../assets/94eea8ec-9d98-4f6c-af76-c52a1f12f871_200x200.png";
const Navbar = () => {
    return (
        <div className={'nav-bar'}>
            <img src={logo} alt="logo"/>
        </div>
    )
}
export default Navbar
